import { render, staticRenderFns } from "./detailApprover.vue?vue&type=template&id=617441bc&scoped=true&"
import script from "./detailApprover.vue?vue&type=script&lang=js&"
export * from "./detailApprover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617441bc",
  null
  
)

export default component.exports